import { MutationTree } from 'vuex';
import { GroupsApplicationsState } from './types';

export const mutations: MutationTree<GroupsApplicationsState> = {
  setGroupsApplications: (state, data) => {
    state.groupsApplications = data;
  },
  setGroupsApplicationItem: (state, data) => {
    state.groupsApplicationItem = data;
  }
};
